export const useRefreshAccessToken = async (refreshToken) => {
  if (!refreshToken) {
    throw new Error('Refresh token is missing');
  }

  const { data, error } = await useApiV3().post('/auth/refresh', { refresh: refreshToken });

  if (error || !data?.access) {
    throw new Error('Refresh token is invalid or expired');
  }

  return data.access;
}
